import * as React from 'react';
import { IconActionArrowDown24 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

export const ArrowDownButton = ({ onClick }: { onClick(): void }) => {
  return (
    <button className={styles['arrow']} onClick={onClick}>
      <IconActionArrowDown24 color="icon-inverted-default" />
    </button>
  );
};
